import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import {FormGroup, Validators } from '@angular/forms';
import { S3ImageUploadService } from 'app/shared/s3-image-upload.service';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { HttpClient } from '@angular/common/http';
import { ViewChild, ElementRef} from '@angular/core';
import { AspWebsiteSettingService } from './asp-website-setting.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-asp-website-setting',
  templateUrl: './asp-website-setting.component.html',
  styleUrls: ['./asp-website-setting.component.scss']
})
export class AspWebsiteSettingComponent implements OnInit {
  websiteSettings: FormGroup;
  newlyUploadedImages: any[];
  selectedImageUrls: string[] = [];
  link: any;
  newlyUploadedImagesLength: any;
  loading: boolean;
  isViewerOpen: boolean = false;
  currentIndex = 0;
  currentTag: string = '';
  selectedImage: string = '';
  showUploadPopup = false;
  imageUpload:FormGroup;

  @ViewChild('fileInput') fileInput!: ElementRef;
selectedFile: File | null = null;

roleType: string [] = [
'General Manager',
'Parts Manager',
'Service Manager',
'Service Advisor',
'Washing Supervisor',
'Body Shop Supervisor',
'Customer Care'
];

insuranceControl = new FormControl();
roleTypeControl = new FormControl();

selectedInsuranceCsv: string = '';
data: any;
insuranceOptions: any;
  roleTypeList: any;



  constructor(
    private _formBuilder: FormBuilder,
    private s3ImageUploadService: S3ImageUploadService,
    private aspLoadingService: AspLoadingService,
    private http: HttpClient,
    private fb: FormBuilder,
    private aspWebsiteSettingService : AspWebsiteSettingService,
    private toastr: ToastrService,
  ) {
    this.imageUpload = this.fb.group({
      fileInput: new FormControl('', Validators.required),
      ImageName: new FormControl('', Validators.required),
      roleType: new FormControl('',Validators.required)
    });
  }
    
   

  ngOnInit(): void {
        this.websiteSettings = this._formBuilder.group({
          // website: ['', [Validators.required]],
          // facebookUrl: ['',[Validators.required]],
          // instagramUrl: ['',[Validators.required]],
          website: ['', [Validators.required, Validators.pattern(/^(https?:\/\/)?([\w\-])+\.{1}([a-zA-Z]{2,63})([\/\w\-\.\?\=\#\&]*)*\/?$/)]],
          facebookUrl: ['', [Validators.required, Validators.pattern(/^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9(\.\?)?]/)]],
          instagramUrl: ['', [Validators.required, Validators.pattern(/^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9(_)?]+\/?$/)]],      
          hasInsurance:['']


        });
        this.fetchInsuranceOptions()
  }
  fetchInsuranceOptions(): void {
    this.aspWebsiteSettingService.submitInsuranceCompaniesList().subscribe(
      (response: any) => {
        const rawOptions = response.data || [];
        // Extract only names
        this.insuranceOptions = rawOptions.map((item: any) => item.name);
      },
      (error) => {
        console.error('Failed to fetch insurance options', error);
      }
    );
  }
                                                      
  onInsuranceSelectionChange(): void {
    const selectedInsurancesArray = this.insuranceControl.value || [];
    const selectedInsurances = selectedInsurancesArray.map(i => `"${i}"`).join(', ');
    // console.log('Selected insurance (CSV):', this.selectedInsuranceCsv);
  }
  onRoleType(): void {
    const selectedRoles = this.roleTypeControl.value || [];
    const formattedRoles = selectedRoles.map(i => `"${i}"`).join(', ');
  }
  openFileSelector(): void {
    this.fileInput.nativeElement.click();
  }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
  
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
  
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const imageUrl = e.target?.result as string;
        this.selectedImageUrls = this.selectedImageUrls || [];
        this.selectedImageUrls.push(imageUrl);
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }
  onUploadClick(): void {
    // console.log("this,name---",this.selectedFile.name);
    if (!this.selectedFile) {
      return;
    }
    this.s3ImageUploadService.getPresignedUrl(this.selectedFile.name).subscribe({
      next: (response) => {
        // console.log("namess---",response);
        const presignedUrl = response[0]?.signedUrl;
        const link = response[0]?.link;
        // console.log("this.presingendurl--",presignedUrl);
        // console.log("link---",link);
  
        if (presignedUrl && link) {
          this.uploadFileToS3(presignedUrl, this.selectedFile, link);
        }
      },
      error: (err) => console.error('Error getting presigned URL:', err),
    });
  }
  uploadFileToS3(presignedUrl: string, file: File, link: string): void {
    this.http.put(presignedUrl, file, {
      headers: { 'Content-Type': file.type },
    }).subscribe({
      next: () => {
        this.showUploadPopup = false;
  
        // Save uploaded image data
        this.newlyUploadedImages = this.newlyUploadedImages || [];
        this.newlyUploadedImages.push({ url: link, tag: this.imageUpload.value.ImageName, roleType: this.roleTypeControl.value});
  
        this.newlyUploadedImagesLength = this.newlyUploadedImages.length;
        // console.log('File uploaded and stored:', this.newlyUploadedImages);
        this.imageUpload.reset();
      },
      error: (err) => {
        console.error('Upload error:', err);
      },
      complete: () => {
        this.loading = false;
        this.aspLoadingService.hide();
      }
    });
  }
  openPopUp()
  {
    this.showUploadPopup = true;
    this.onRoleTypeList();
  }

  onRoleTypeList(){
    this.aspWebsiteSettingService.roleTypeList().subscribe((response:any) => {
        this.roleTypeList = response.data;
  });
}
  

  openViewer(index: number) {
    this.currentIndex = index;
    // console.log("this.newlyUploadedImages");
    this.selectedImage = this.newlyUploadedImages[this.currentIndex].url;
    this.isViewerOpen = true;
  }
  prevImage1() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.selectedImage = this.newlyUploadedImages[this.currentIndex].url;
    }
  }

  nextImage1() {
    if (this.currentIndex < this.newlyUploadedImages.length - 1) {
      this.currentIndex++;
      this.selectedImage = this.newlyUploadedImages[this.currentIndex].url;
    }
  }
  removeImage(imageToRemove: any): void {
    this.newlyUploadedImages = this.newlyUploadedImages.filter(image => image !== imageToRemove);
  }
  
  submitData() {
    const websiteFormValues = this.websiteSettings.value.website;
    const facebookFormValues = this.websiteSettings.value.facebookUrl;
    const instagramFormValues = this.websiteSettings.value.instagramUrl;
    const formattedRoles = this.roleTypeControl.value;

    const selectedInsurances = this.insuranceControl.value;
    const uploadedImages = (this.newlyUploadedImages || []).map(img => ({
      url: img.url,
      tag: img.tag,
      roleType:img.roleType.name || ''
    }));
  
    const cleanData = {
      // ...websiteFormValues,
      garageKey: localStorage.getItem('garageKey'),
      // garageKey : "5eb37789997c32ed23ac56a08ceeea2d",
      userKey : localStorage.getItem('spareUserKey'),
      // userKey:"1ab4a1c5ec58a9d596a969bd85f49e4c",
      // roleType : formattedRoles,
      websiteUrl: websiteFormValues || '',
      instagramUrl : instagramFormValues || '',
      insuranceNames: selectedInsurances || '',
      facebookUrl:facebookFormValues || '',
      teamPhotos: uploadedImages || ''
    };
  
    // console.log('Submitting data:', cleanData);
    this.aspWebsiteSettingService.submit(cleanData).subscribe(
      (response:any) => {
        if(response.code === 200){
        this.data = response.data;
        this.toastr.success("Data Saved Sucesfully")
        this.websiteSettings.reset();

        this.newlyUploadedImages = [];
        this.insuranceControl.reset();
        this.selectedImageUrls = [];
        this.selectedFile = null;
        this.imageUpload.reset();
        this.newlyUploadedImagesLength = 0;
        // this.showUploadPopup = false;
        // this.isViewerOpen = false;
      }
      else{
        this.toastr.error("Unsuccessfull Please try again");
      }

  });
}
@HostListener('document:keydown', ['$event'])
handleKeyboardEvent(event: KeyboardEvent): void {
  if (!this.isViewerOpen) return;

  if (event.key === 'ArrowLeft') {
    this.prevImage1();
  } else if (event.key === 'ArrowRight') {
    this.nextImage1();
  } else if (event.key === 'Escape') {
    this.isViewerOpen=false;
  }
}
}


